import setFullbanner from './home/1_fullbanner';
import setBrandsCarousel from './home/brands_carousel';
import setCarousel from '../components/carousel';
import setSliderGrids from './home/4_categories';
import setReviewsSwiper from './home/reviews';
//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setBrandsCarousel();
		setCarousel();
		setSliderGrids();
		setReviewsSwiper();
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
